export default __webpack_public_path__ + "static/media/emission-icon.a178258f.svg";